export default __webpack_public_path__ + "cd1672d1954e1f39410267907015ccb8.svg";